import { Message } from '@com-delta-idp/mnx-capability-flyout-ui';
import {
  APP_MESSAGES_ERROR,
  checkStringValueNull,
  Errormessage,
  transformToMap
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { DEFAULT_ERROR_MESSAGE } from '../../models/constants/today/today-trip.constants';
import { FLIGHT_NUMBER } from '../../models/constants/todays-trip-constants/todays-trip.constants';
import { TodaysTrip } from '../../models/interfaces/todays-trip/todays-trip.interface';

export const getShowIropModel = (todayTrip: TodaysTrip): boolean => {
  return todayTrip?.trip?.iropClean || todayTrip?.trip?.iropImpact
    ? true
    : false;
};

export const getShowErrorMessage = (todayTrip: TodaysTrip): boolean => {
  return getShowIropModel(todayTrip) || checkTripsError(todayTrip)
    ? true
    : false;
};

export const checkTripsError = (todayTrip: TodaysTrip): boolean => {
  return !(
    todayTrip?.errors !== null &&
    todayTrip?.errors !== undefined &&
    todayTrip?.errors?.length === 0
  )
    ? true
    : false;
};

export const getErrorMessages = (
  error: APP_MESSAGES_ERROR,
  todayTrip: TodaysTrip,
  irop: boolean
): { errorMessageTitle: string; errorMessageDescription: string } => {
  const errorMap = transformToMap(error);

  if (!errorMap) {
    return DEFAULT_ERROR_MESSAGE;
  }
  const iropMessage = todayTrip?.trip?.iropMessage || 'SYS_ERROR';
  const errorObject = getErrorMessage(iropMessage, irop, errorMap);

  if (!irop) {
    return errorObject;
  }
  return {
    errorMessageTitle: replaceFlightStatusNumber(errorObject, todayTrip),
    errorMessageDescription: errorObject?.errorMessageDescription
  };
};

const findInMap = (errorMap: Map<string, Message>, key: string): Message => {
  const direct = errorMap.get(key);
  if (direct) return direct;
  for (const [k, v] of errorMap) {
    if (k.replace(/ /g, '_') === key) return v;
  }
  return DEFAULT_ERROR_MESSAGE;
};

export const getErrorMessage = (
  iropMessage: string,
  irop: boolean,
  errorMap: Map<string, Message> | null
): Message => {
  if (!errorMap) return DEFAULT_ERROR_MESSAGE;
  const key = (irop ? iropMessage : 'TDY_SYS_ERR').replace(/ /g, '_');
  return findInMap(errorMap, key);
};

export const toTitleCase = (str: string): string => {
  if (!str) return str;
  str = checkStringValueNull(str);
  return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

export const replaceFlightStatusNumber = (
  errorObject: Message,
  todayTrip: TodaysTrip
): string => {
  if (!errorObject) return '';
  if (errorObject.errorMessageTitle?.includes(FLIGHT_NUMBER)) {
    return errorObject.errorMessageTitle.replace(
      FLIGHT_NUMBER,
      `${todayTrip?.trip?.mktCarrierCode} ${todayTrip?.trip?.mktFlightNumber}`
    );
  }
  return errorObject.errorMessageTitle || '';
};

export const errorMessageMethod = (
  todayTrip: TodaysTrip,
  errorMessages: APP_MESSAGES_ERROR
) => {
  return getShowIropModel(todayTrip)
    ? getErrorMessages(errorMessages, todayTrip, true)
    : checkTripsError(todayTrip)
      ? getErrorMessages(errorMessages, todayTrip, false)
      : ({} as Errormessage);
};
